import { useState } from "react";

import DotsHorizontal from "@uui/DotsHorizontal";
import EditIcon from "@uui/Edit02";
import FileXIcon from "@uui/FileX03";

import Divider from "@mui/material/Divider";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import RemoveTopicReportConfirmationModal from "@app/analytics/components/reports/RemoveTopicReportConfirmationModal";
import useRemoveTopicReport from "@app/analytics/hooks/topics/useRemoveTopicReport";
import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";
import type { Topic } from "@app/analytics/types";
import { toast } from "@app/common/hooks/useToasts";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu from "@rui/Menu";
import MenuItem from "@rui/MenuItem";

const ReportActionsMenu = ({
  topic,
  shared,
}: {
  topic: Topic;
  shared: boolean;
}) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const setShowRemoveFeedbackModal = useTopicReportStore(
    (state) => state.setShowRemoveFeedbackModal
  );

  const { removeTopicReport, isRemoving } = useRemoveTopicReport();

  const {
    anchorElement,
    onClick,
    onClose: onMenuClose,
    open,
  } = useAnchorElement();

  const openModal = () => {
    onMenuClose();
    setConfirmationModalOpen(true);
  };

  const closeModal = () => setConfirmationModalOpen(false);

  const handleEditReportTitle = () => {
    onMenuClose();
    const element = document.getElementById("topic-report-title");
    element?.click();
  };

  const handleRemoveReport = () => {
    return removeTopicReport(
      {
        topicId: topic.id,
        ownerUserId: topic.ownerUserId,
      },
      {
        onSuccess: () => setShowRemoveFeedbackModal(true),
        onError: () => {
          closeModal();
          toast.error(
            "Something went wrong and your report could not be removed."
          );
        },
      }
    );
  };

  return (
    <>
      <HeaderButton Icon={<DotsHorizontal />} onClick={onClick} />
      <Menu anchorEl={anchorElement} open={open} onClose={onMenuClose}>
        {!shared && (
          <MenuItem icon={<EditIcon />} onClick={handleEditReportTitle}>
            Rename Report
          </MenuItem>
        )}
        {!shared && <Divider />}
        <MenuItem icon={<FileXIcon />} onClick={openModal} type="error">
          Remove Report
        </MenuItem>
      </Menu>
      <RemoveTopicReportConfirmationModal
        loading={isRemoving}
        open={confirmationModalOpen}
        onClose={closeModal}
        onConfirm={handleRemoveReport}
      />
    </>
  );
};

export default ReportActionsMenu;
